import React, { useState, useMemo, useEffect, useRef } from "react";
import { Card, CardHeader, CardBody, Row, Col, Label, FormGroup, Nav, NavItem, NavLink, Table, Button, Modal, ModalBody, Input, ModalFooter, FormFeedback, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Tooltip } from "reactstrap";
import { LabelText } from "../Utils/Input";
import PieChart from "./constants/PieChart";
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import SelectField from "../Utils/SelectField";
import classnames from 'classnames';
import { goToIndex, next, previous } from "./constants/corouselNavigation";
import { viewDoc } from "../../slices/customer/documentview/thunk";
import logoLarge from '../../assets/images/users/user-dummy-img.jpg'
import CommonButton from "../Utils/CommonButton";
import { useNavigate } from "react-router-dom";
import { adjustJsonObject } from "./constants/CustomerJsonObj";
import { recharge } from "../../slices/Recharge/thunk";
import { setSuccessMessage } from "../../slices/toastMessage/action";
import { ToastContainer, toast } from "react-toastify";
import { getAllResources } from "../../slices/resources/thunk";
import { FormattedNumber, FormattedNumbers } from "./constants/FormatNumber";
import CustomerAdjustmentModal from "./CustomerAdjustmentModal";
import { UOMPrefixes } from "../Utils/Constants";
import { Loader } from "../Utils/Loader";

export const CustomerProfile = ({ customerPermission, customerData, fetchCustomerSummaryData, formatDate, isRefreshing }) => {
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState("");
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);
    const [activeTabForAddOn, setActiveTabForAddOn] = useState("1");
    const [addOnLength, setAddOnLength] = useState(0);
    const [baseOfferLength, setBaseOfferLength] = useState(0);
    const [profileData, setProfileData] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [chartKey, setChartKey] = useState(0); // Add key for force re-render
    const [profileImage, setProfileImage] = useState(logoLarge);
    const [loading, setLoading] = useState(false);
    const [chargedResource, setChargedResource] = useState([]);
    const [carouselSubscription, setCarouselSubscription] = useState(null)
    const [tooltipOpen1, setTooltipOpen1] = useState(false);
    const [tooltipOpen2, setTooltipOpen2] = useState(false);
    const [maxLength, setMaxLength] = useState(12);
    const spanRef = useRef(null);
    const containerRef = useRef(null);
    const [isColumn, setIsColumn] = useState(false);

    const currencies = useSelector((state) => state.GetAllCurrency.GetAllCurrency)
    const fetchCustomerSummaryDataError = useSelector(state => state.Simulate.error)

    const toggle1 = () => setTooltipOpen1(!tooltipOpen1);
    const toggle2 = () => setTooltipOpen2(!tooltipOpen2);
    const roleName = localStorage.getItem('roleName')
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen)
    };
    const toggleModal = (type = "") => {
        setModalType(type);
        setModalOpen(!modalOpen);
    };

    const navigateToView = useNavigate()
    const dispatch = useDispatch()

    const tabChange = (tab) => {
        if (activeTabForAddOn !== tab) {
            setActiveTabForAddOn(tab);
            setActiveIndex(0);
            setChartKey(prev => prev + 1);
        }
    };
    const groupedResources = useMemo(() => {
        return fetchCustomerSummaryData?.resources?.reduce((acc, resource) => {
            const key = `${resource.subscriptionId}`;
            // Find matching subscription and offer
            let subscriptionValidFrom = null;
            let subscriptionValidTo = null;
            if (customerData?.subscriptionList) {
                const sub = customerData.subscriptionList.find(
                    s => s.subscriptionId === resource.subscriptionId
                );
                if (sub && Array.isArray(sub.subscribedOffers)) {
                    const offer = sub.subscribedOffers.find(
                        o => o.offerCode === resource.offerCode
                    );
                    if (offer) {
                        subscriptionValidFrom = offer.validFrom || null;
                        subscriptionValidTo = offer.validTo || null;
                    }
                }
            }
            const resourceWithDates = {
                ...resource,
                subscriptionValidFrom,
                subscriptionValidTo
            };
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(resourceWithDates);
            return acc;
        }, {});
    }, [fetchCustomerSummaryData, customerData]);

    useEffect(() => {
        if (roleName !== 'Customer')
            dispatch(getAllResources(setLoading));
    }, [dispatch, setLoading]);
    const resource = useSelector((state) => state.Resources.resources);
    const initialAdjustValues = {
        description: "",
        adjustmentAmount: "",
        resourceName: "",
        balanceItemSpecId: "",
        subscriptionId: "",
        offerCode: "",
        validFrom: null,
        validTo: null,
    }
    const initialCurrencyAdjustValues = {
        description: "",
        adjustmentAmount: "",
        resourceName: "",
    }
    const initialRechargeValues = {
        adjustmentAmount: "",
        resourceName: "",
    }
    const handleSubscriptionChange = (selectedOption) => {
        setSelectedSubscriptionId(selectedOption ? selectedOption.value : "");
        setActiveIndex(0);
        setChartKey(prev => prev + 1);
    };
    const uniqueSubscriptionIds = useMemo(() => {
        if (fetchCustomerSummaryData?.resources) {
            const subscriptionIds = [...new Set(
                fetchCustomerSummaryData?.resources?.filter(resource => !resource.isAggregate && resource.subscriptionId)?.map(resource => resource.subscriptionId)
            )];
            if (subscriptionIds?.length === 0 && customerData?.subscriptionList) {
                const subscriptionIdsFromCustomerData = [...new Set(
                    (customerData?.subscriptionList || [])?.map(sub => sub.subscriptionId)
                )];
                return subscriptionIdsFromCustomerData;
            }
            return subscriptionIds;
        } else if (customerData?.subscriptionList) {
            const subscriptionIds = [...new Set(
                (customerData?.subscriptionList || [])?.map(sub => sub.subscriptionId)
            )]
            return subscriptionIds;
        } else return [];
    }, [fetchCustomerSummaryData, customerData]);

    useEffect(() => {
        if (!fetchCustomerSummaryData?.resources) return;
        const filteredResources = fetchCustomerSummaryData.resources.filter(resource => {
            if (resource.subscriptionId !== selectedSubscriptionId) return false;
            if (activeTabForAddOn === "1") {
                return !resource.isAddOn;
            } else {
                return resource.isAddOn;
            }
        });

        if (filteredResources.length > 0 && filteredResources[activeIndex]) {
            setCarouselSubscription(filteredResources[activeIndex].offerName);
        } else {
            setCarouselSubscription(null);
        }
    }, [fetchCustomerSummaryData, activeTabForAddOn, selectedSubscriptionId]);

    const showSuccessMessage = useSelector(
        (state) => state.SuccessToast.showSuccessMessage
    );
    useEffect(() => {
        if (showSuccessMessage && modalType === "Recharge") {
            toast.success(`Recharge Successful!`);
            dispatch(setSuccessMessage(false));
        }
        if (showSuccessMessage && modalType !== "Recharge") {
            toast.success(`Adjustment Successful!`);
            dispatch(setSuccessMessage(false));
        }
    }, [showSuccessMessage, dispatch]);

    useEffect(() => {
        const addOns = fetchCustomerSummaryData?.resources?.filter(resource => resource.isAddOn) || [];
        const chargeResource = fetchCustomerSummaryData?.resources?.filter(resource => resource.currencyCode) || [];
        const nonchargeResource = fetchCustomerSummaryData?.resources?.filter(resource => !resource.currencyCode) || [];
        setAddOnLength(addOns.length || 0);
        setBaseOfferLength(nonchargeResource.length || 0);
        setChargedResource(chargeResource);
    }, [fetchCustomerSummaryData?.resources]);
    useEffect(() => {
        if (uniqueSubscriptionIds.length > 0) {
            if (!selectedSubscriptionId || !uniqueSubscriptionIds.includes(selectedSubscriptionId)) {
                setSelectedSubscriptionId(uniqueSubscriptionIds[0]);
                setActiveIndex(0);
                setChartKey(prev => prev + 1);
            }
        } else {
            setSelectedSubscriptionId("");
        }
    }, [uniqueSubscriptionIds, selectedSubscriptionId]);
    useEffect(() => {
        if (customerData?.customerInfo?.customerId) {
            setSelectedSubscriptionId("");
            setActiveIndex(0);
            setChartKey(prev => prev + 1);
        }
    }, [customerData?.customerInfo?.customerId]);

    useEffect(() => {
        if (customerData && customerData?.customerInfo?.userName) {
            let partnerOrCustomer = "Customer"
            dispatch(viewDoc(setLoading, customerData?.customerInfo?.customerId, "logo", partnerOrCustomer, setProfileData))
        }
    }, [dispatch, customerData]);

    let ViewDocument = useSelector(state => state.ViewDocument.documentView)
    let base64ImageData = ViewDocument?.filePath
    useEffect(() => {
        if (base64ImageData) {
            setProfileImage(base64ImageData)
        } else {
            setProfileImage(logoLarge)
        }
    }, [base64ImageData])

    const handleBalanceConfirm = (values) => {
        let jsonObject
        jsonObject = adjustJsonObject(values, modalType, customerData?.customerInfo?.customerId)
        dispatch(recharge(jsonObject, setLoading))
        setModalOpen(false);
    };
    const handleConfirm = (values) => {
        let jsonObject = adjustJsonObject(values, modalType, customerData?.customerInfo?.customerId);
        dispatch(recharge(jsonObject, setLoading));
        setModalOpen(false);
    };



    // Utility: middle truncate
    function truncateMiddle(text, maxLength) {
        if (!text) return "";
        if (text.length <= maxLength) return text;

        // Ensure minimum 3 characters visible (1…1)
        const minVisible = Math.max(1, Math.floor(maxLength / 4));

        const head = Math.max(minVisible, Math.ceil(maxLength / 3));
        const tail = Math.max(minVisible, Math.floor(maxLength / 3));

        // If maxLength is too small, show first few chars + …
        if (head + tail > maxLength) {
            return text.slice(0, maxLength - 1) + "…";
        }

        return text.slice(0, head) + "…" + text.slice(-tail);
    }


    // Reusable BalanceNumber
    const BalanceNumber = ({ id, value }) => {
        const text = (value ?? "").toString();
        const [tooltipOpen, setTooltipOpen] = useState(false);
        const [maxLength, setMaxLength] = useState(text.length);
        const spanRef = useRef(null);

        useEffect(() => {
            let timeout;

            const updateMaxLength = () => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    const vw = window.visualViewport?.width || window.innerWidth;

                    let calculatedMaxLength;
                    if (vw >= 2200) calculatedMaxLength = 40;
                    else if (vw >= 1950) calculatedMaxLength = 35;
                    else if (vw >= 1820) calculatedMaxLength = 30;
                    else if (vw >= 1620) calculatedMaxLength = 25;
                    else if (vw >= 1200) calculatedMaxLength = 20;
                    else if (vw >= 992) calculatedMaxLength = 16;
                    else if (vw >= 768) calculatedMaxLength = 12;
                    else calculatedMaxLength = 8;

                    setMaxLength(calculatedMaxLength);
                }, 50);
            };

            updateMaxLength();

            window.addEventListener("resize", updateMaxLength);
            window.visualViewport?.addEventListener("resize", updateMaxLength);

            return () => {
                window.removeEventListener("resize", updateMaxLength);
                window.visualViewport?.removeEventListener("resize", updateMaxLength);
                clearTimeout(timeout);
            };
        }, [text]);

        return (
            <>
                <span
                    ref={spanRef}
                    id={id}
                    style={{
                        display: "inline-block",
                        minWidth: 0,
                        //   maxWidth: "45%", // adjust to your design
                        flexShrink: 1,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "clip", // middle truncation handled in JS
                    }}
                >
                    {truncateMiddle(text, maxLength)}
                </span>

                <Tooltip
                    placement="top"
                    isOpen={tooltipOpen}
                    target={id}
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {text}
                </Tooltip>
            </>
        );
    };

    useEffect(() => {
        const checkLayout = () => {
            if (!containerRef.current) return;

            const activeItem = containerRef.current.querySelector('.carousel-item.active') ||
                containerRef.current.querySelector('.carousel-item');

            if (!activeItem) return;

            const contentWidth = activeItem.offsetWidth;
            setIsColumn(contentWidth < 370);
        };
        checkLayout();
        window.addEventListener("resize", checkLayout);
        return () => window.removeEventListener("resize", checkLayout);
    }, []);

    const renderGrantsCarousel = (resources) => {
        if (!resources || resources.length === 0) return null;
        const isMultipleResources = resources.length > 1;


        const slides = resources.map((resource, index) => {
            const isCurrencyCode = currencies?.some(currency => currency.currencyCode === resource?.uom);
            const isCurrencySymbol = currencies?.some(currency => currency.symbol === resource?.uom);
            const isCurrency = isCurrencyCode || isCurrencySymbol || UOMPrefixes.includes(resource?.uom);
            return (
                <CarouselItem
                    onExiting={() => setAnimating(true)}
                    onExited={() => setAnimating(false)}
                    key={`${resource.resourceName}-${index}-${chartKey}`}
                    className="h-100"
                >
                    <div className="px-4 my-2 bg-white mb-1 h-100 d-flex flex-column grant-card">

                        {/* Header */}
                        <div className="flex-shrink-0">
                            <p className="fw-bolder fs-5 justify-content-start mt-2 mb-2 rv-text-color">
                                Grants
                            </p>
                        </div>

                        {/* Scrollable content */}
                        <div
                            className="flex-grow-1 d-flex flex-column w-100"
                            style={{
                                overflowY: "auto",   // ✅ allow scroll if content is too tall
                                overflowX: "hidden",
                                maxHeight: "calc(100% - 60px)",
                                minHeight: 0,
                                minWidth: 0,
                            }}
                        >
                            {/* Resource Name */}
                            <div className="w-100" style={{ minWidth: 0 }}>
                                <p
                                    className="fw-semibold fs-5 text-start d-block w-100 text-wrap"
                                    style={{
                                        overflowWrap: "break-word",
                                        wordBreak: "break-word",
                                        whiteSpace: "normal"
                                    }}
                                    title={resource?.resourceName}
                                >
                                    {resource?.resourceName}
                                </p>
                            </div>

                            {/* Pie Chart */}
                            <div className="d-flex w-100 justify-content-around justify-content-lg-center grant-content flex-fill"
                                ref={containerRef}
                                style={{
                                    flexDirection: isColumn ? "column" : "row"
                                }}
                            >
                                <div className="ms-0">
                                    <div className="mb-3 flex-shrink-0 d-flex justify-content-center">
                                        <PieChart
                                            key={`pie-${resource.resourceName}-${index}-${chartKey}`}
                                            remainingBalance={resource?.remainingBalance || "0"}
                                            originalBalance={resource?.originalBalance || "0"}
                                            width={window.innerWidth < 576 ? 175 : 200}   // ✅ smaller on mobile
                                            height={window.innerWidth < 576 ? 175 : 200}
                                        />
                                    </div>
                                </div>
                                <div className="align-middle align-self-center ms-1 text-wrap">
                                    {/* Offer Name */}
                                    <div className="text-center w-100 mb-2 text-wrap" style={{ minWidth: "150px" }}>
                                        <span
                                            className="fw-bold fs-5 d-block w-100"
                                            style={{
                                                overflowWrap: "break-word",
                                                wordBreak: "break-word",
                                            }}
                                            title={resource?.offerName}
                                        >
                                            {resource?.offerName}
                                        </span>
                                    </div>

                                    {/* Balances */}
                                    <div
                                        className="d-flex justify-content-center text-wrap align-items-center flex-wrap mb-2 fw-semibold"
                                        style={{
                                            lineHeight: 1.4,
                                            minWidth: 0,
                                            overflowWrap: "break-word",
                                            wordBreak: "break-word",
                                            whiteSpace: "normal"
                                        }}
                                    >
                                        {isCurrency && <span className={`${isCurrencyCode ? 'me-1' : ''} flex-shrink-0`}>{resource?.uom}</span>}
                                        {isCurrency ? resource?.remainingBalance?.toFixed(2) : <BalanceNumber id={`remaining-${index}`} value={resource?.remainingBalance} />}
                                        {!isCurrency && '$' && <span className="mx-1 flex-shrink-0">{resource?.uom || ''}</span>}
                                        <span className={`${!isCurrency ? 'me-1' : 'mx-1'} flex-shrink-0`}>left of</span>
                                        {isCurrency && <span className={`${isCurrencyCode ? 'me-1' : ''}`}>{resource?.uom || ''}</span>}
                                        {isCurrency ? resource?.originalBalance?.toFixed(2) : <BalanceNumber id={`original-${index}`} value={resource?.originalBalance} />}
                                        {!isCurrency && <span className="ms-1 flex-shrink-0">{resource?.uom}</span>}
                                    </div>

                                    {/* Validity Dates */}
                                    <div
                                        className="text-center w-100 text-wrap text-break flex-shrink: 1"
                                        style={{ minWidth: 0 }}
                                        title={`${formatDate(resource.validFrom)} - ${formatDate(resource.validTo)}`}
                                    >
                                        <LabelText
                                            displayText={`${formatDate(resource.validFrom)} - ${formatDate(resource.validTo)}`}
                                            classLabelName="text-wrap d-block w-100"
                                            style={{
                                                display: "block",
                                                width: "100%",
                                                overflowWrap: "break-word",
                                                wordBreak: "break-word",
                                                whiteSpace: "normal"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </CarouselItem>
            )
        });

        return (
            <div
                ref={containerRef}
                style={{
                    minHeight: isColumn ? "390px" : "300px",
                    maxHeight: isColumn ? "390px" : "300px",
                    overflow: "hidden",
                }}
                className="border rounded-1"
            >
                <Carousel
                    key={`carousel-${chartKey}`}
                    activeIndex={activeIndex}
                    next={
                        isMultipleResources
                            ? () =>
                                next(resources, activeIndex, setActiveIndex, animating, setCarouselSubscription)
                            : undefined
                    }
                    previous={
                        isMultipleResources
                            ? () =>
                                previous(resources, activeIndex, setActiveIndex, animating, setCarouselSubscription)
                            : undefined
                    }
                    interval={false}
                    className="h-100"
                >
                    {slides}
                    {isMultipleResources && (
                        <>
                            <CarouselControl
                                className="ms-n3 mt-5"
                                direction="prev"
                                directionText="Previous"
                                onClickHandler={() =>
                                    previous(resources, activeIndex, setActiveIndex, animating, setCarouselSubscription)
                                }
                            />
                            <CarouselControl
                                className="me-n3 mt-5"
                                direction="next"
                                directionText="Next"
                                onClickHandler={() =>
                                    next(resources, activeIndex, setActiveIndex, animating, setCarouselSubscription)
                                }
                            />
                        </>
                    )}
                </Carousel>
            </div>
        );
    };


    function extractOptionsFromResources(resources, key, isCurrency) {
        if (!Array.isArray(resources)) return [];
        const seenValues = new Set();
        return resources
            .map((resource) => {
                if (key === "name" || key === "resourceName") {
                    if ((isCurrency && !resource?.currencyCode) || (!isCurrency && resource?.currencyCode)) {
                        return null;
                    }
                }
                const value = resource[key];
                if (value !== undefined && value !== null && value !== "" && !seenValues.has(value)) {
                    seenValues.add(value);
                    return {
                        label: String(value),
                        value: value,
                    };
                }
                return null;
            })
            .filter(Boolean);
    }

    const currencyRechargeArray = extractOptionsFromResources(resource, "name", true)
    const currencyAdjustArray = extractOptionsFromResources(fetchCustomerSummaryData?.resources, "resourceName", true);
    const nonCurrencyAdjustArray = extractOptionsFromResources(fetchCustomerSummaryData?.resources, "resourceName", false)
    const idArray = extractOptionsFromResources(fetchCustomerSummaryData?.resources, "id");
    const subscriptionIdArray = extractOptionsFromResources(fetchCustomerSummaryData?.resources, "subscriptionId");
    const offerCodeArray = extractOptionsFromResources(fetchCustomerSummaryData?.resources, "offerCode");

    const today = new Date();
    const allOffersExpired = groupedResources && Object.values(groupedResources).flat().length > 0 &&
        Object.values(groupedResources).flat().every(resource => {
            if (!resource.subscriptionValidTo || resource.subscriptionValidTo === "0001-01-01T00:00:00Z") return false;
            return new Date(resource.subscriptionValidTo) < today;
        });
    const operatorConfiguration = useSelector((state) => state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration);
    const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

    return (
        <>
            {isRefreshing && (<Loader />)}
            <Row lg={12}>
                <Col lg={12}>
                    <div className="px-2 py-1 bg-white">
                        {(uniqueSubscriptionIds?.length > 0 || selectedSubscriptionId || chargedResource?.length) ? <Row className="border rounded-1 position-relative">
                            {/* Subscription Select */}
                            <Col lg={5} md={12} sm={12} xs={12}>
                                <FormGroup>
                                    <Label for="subscriptionSelect" className="fw-bold mt-1 p-2">
                                        Subscription ID
                                    </Label>
                                    <div className="w-100">
                                        <SelectField
                                            id="subscriptionSelect"
                                            value={
                                                selectedSubscriptionId
                                                    ? { value: selectedSubscriptionId, label: selectedSubscriptionId }
                                                    : null
                                            }
                                            placeholder="Select Subscription ID"
                                            handleChange={handleSubscriptionChange}
                                            options={uniqueSubscriptionIds?.map((id) => ({
                                                value: id,
                                                label: id,
                                            }))}
                                            isMulti={false}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                            {/* Balance Card */}
                            {chargedResource?.[0] && (
                                <>
                                    <Col lg={1} md={12} className="d-flex justify-content-center">
                                        <div
                                            style={{
                                                borderLeft: "1px solid #DFDFDF",
                                                height: "90%",
                                                marginTop: "10px"
                                            }}
                                        ></div>
                                    </Col>
                                    <Col lg={6} md={12} sm={12} xs={12}>
                                        <div className="mb-3 mt-5">
                                            <div className="text-center">
                                                <h5 className="fw-semibold rv-text-color">{chargedResource[0]?.type == 'Prepaid' ? 'Available Balance' : 'Balance Due'}</h5>
                                                <p className="fw-bold text-dark fs-1 mb-1" style={{ wordBreak: "break-word" }}>
                                                    {chargedResource[0]?.remainingBalance < 0
                                                        ? `-${chargedResource[0]?.currencySymbol || chargedResource[0]?.currencyCode}${Math.abs(chargedResource[0]?.remainingBalance ?? 0).toFixed(2)}`
                                                        : `${chargedResource[0]?.currencySymbol || chargedResource[0]?.currencyCode}${Math.abs(chargedResource[0]?.remainingBalance ?? 0).toFixed(2)}`}
                                                </p>
                                                {/* <p className="fs-6 fw-medium mb-0">
                                                    {chargedResource[0]?.type == 'Prepaid' ? 'Left to spend' : ''}
                                                </p> */}
                                            </div>
                                        </div>
                                    </Col>
                                </>
                            )}
                            {/* <div style={{ borderTop: "1px solid #e9ebec"}} className="me-n5 ms-1"></div> */}
                        </Row> : null}
                        {groupedResources && Object.keys(groupedResources).length > 0 ? (
                            allOffersExpired ? (
                                <div className="border rounded-1 border-top-0 d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
                                    No active subscriptions.
                                </div>
                            ) : (
                                <>
                                    {selectedSubscriptionId && groupedResources &&
                                        Object.keys(groupedResources)?.filter(key => key.startsWith(selectedSubscriptionId)).length > 0 ? (
                                        <Row className="border rounded-1 border-top-0 align-items-stretch pt-3" style={{ minHeight: "350px" }}>
                                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className="d-flex flex-column">
                                                <Row className="align-items-center mb-3">
                                                    <Col lg={5} md={12} sm={12} xs={12} className="mb-3 mb-xl-0">
                                                        <Nav className="d-flex justify-content-start" role="tablist">
                                                            <NavItem>
                                                                <NavLink
                                                                    onClick={() => tabChange('1')}
                                                                    className={classnames(
                                                                        'fw-semibold',
                                                                        'cursor-pointer',
                                                                        { active: activeTabForAddOn === '1' },
                                                                        { 'text-rv-primary border-rv-primary': activeTabForAddOn === '1' },
                                                                        { 'text-dark': activeTabForAddOn !== '1' }
                                                                    )}
                                                                >
                                                                    Base Offer
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem>
                                                                <NavLink
                                                                    onClick={() => tabChange('2')}
                                                                    className={classnames(
                                                                        'fw-semibold',
                                                                        'cursor-pointer',
                                                                        { active: activeTabForAddOn === '2' },
                                                                        { 'text-rv-primary border-rv-primary': activeTabForAddOn === '2' },
                                                                        { 'text-dark': activeTabForAddOn !== '2' }
                                                                    )}
                                                                >
                                                                    Add‑On Offer
                                                                </NavLink>
                                                            </NavItem>
                                                        </Nav>
                                                    </Col>
                                                    <Col lg={7} md={12} sm={12} xs={12}>
                                                        <div className="d-flex justify-content-end gap-2 flex-wrap mb-2 mb-lg-0">
                                                            {roleName !== "Customer" && !isEIPEnabled && (
                                                                <>
                                                                    {/* {chargedResource?.[0] && ( */}
                                                                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                                                        <DropdownToggle caret className="d-flex bg-secondary text-white rounded-1 px-4 py-1 align-items-center">
                                                                            Adjust
                                                                        </DropdownToggle>
                                                                        <DropdownMenu>
                                                                            <DropdownItem
                                                                                className="text-primary border-bottom"
                                                                                onClick={() => {
                                                                                    setModalType("Adjust");
                                                                                    setModalOpen(true);
                                                                                }}
                                                                            >
                                                                                Currency
                                                                            </DropdownItem>
                                                                            <DropdownItem
                                                                                className="text-primary"
                                                                                onClick={() => {
                                                                                    setModalType("Adjustment");
                                                                                    setModalOpen(true);
                                                                                }}
                                                                            >
                                                                                Non - Currency
                                                                            </DropdownItem>
                                                                        </DropdownMenu>
                                                                    </Dropdown>
                                                                    {/* )} */}
                                                                    <CommonButton
                                                                        color="secondary"
                                                                        className="bg-secondary text-white rounded-1 px-4 py-1"
                                                                        buttonAction={() => {
                                                                            setModalType("Recharge");
                                                                            setModalOpen(true);
                                                                        }}
                                                                        buttonText={"Recharge"}
                                                                    />
                                                                </>
                                                            )}
                                                            {roleName === "Customer" && activeTabForAddOn === "1" && (
                                                                <>
                                                                    <CommonButton
                                                                        color="secondary"
                                                                        className="px-4"
                                                                        buttonAction={() => { navigateToView(`/selfcare-changeplan/${selectedSubscriptionId}`) }}
                                                                        buttonText={"Change Plan"}
                                                                    />
                                                                    <CommonButton
                                                                        color="secondary"
                                                                        className="px-4"
                                                                        buttonAction={() => { navigateToView(`/selfcare-addon/${selectedSubscriptionId}`) }}
                                                                        buttonText={"Purchase Add-On"}
                                                                    />
                                                                </>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center my-2">
                                                    {activeTabForAddOn === "1" && (baseOfferLength <= 0 || (groupedResources[selectedSubscriptionId] || []).filter(r => !r.isAddOn).length <= 0) && (
                                                        <div className="text-center ">
                                                            <p className="fw-bold fs-5 balance-heading-color d-flex justify-content-center align-items-center ">
                                                                No Base Offer purchased for this subscription
                                                            </p>
                                                        </div>
                                                    )}
                                                    {activeTabForAddOn === "2" && (addOnLength <= 0 || (groupedResources[selectedSubscriptionId] || []).filter(r => r.isAddOn).length <= 0) && (
                                                        <div className="text-center ">
                                                            <p className="fw-bold fs-5 balance-heading-color d-flex justify-content-center align-items-center ">
                                                                No Add-Ons purchased for this subscription
                                                            </p>
                                                        </div>
                                                    )}
                                                    {selectedSubscriptionId &&
                                                        Object.keys(groupedResources)?.filter(key => key.startsWith(selectedSubscriptionId)).map((key, index) => {
                                                            const resources = groupedResources[key];
                                                            const filteredResources = resources?.filter(resource =>
                                                                (activeTabForAddOn === "1" && !resource.isAddOn) ||
                                                                (activeTabForAddOn === "2" && resource.isAddOn)
                                                            );
                                                            const ResourceNonCounter = filteredResources?.filter(resource => !resource?.isCounter)
                                                            return (
                                                                <div key={index} className="w-100">
                                                                    {filteredResources?.length > 0 && (
                                                                        <Row className="mb-0 d-flex align-items-stretch">
                                                                            {/* Mobile: Stack vertically, Desktop: Side by side */}
                                                                            {ResourceNonCounter?.length > 0 && (
                                                                                <Col

                                                                                    lg={5}
                                                                                    md={12}
                                                                                    sm={12}
                                                                                    xs={12}
                                                                                    className="flex-fill mb-xl-0 order-xs-2 order-xl-1"
                                                                                >
                                                                                    {renderGrantsCarousel(ResourceNonCounter)}
                                                                                </Col>
                                                                            )}
                                                                            <Col

                                                                                lg={7}
                                                                                md={12}
                                                                                sm={12}
                                                                                xs={12}
                                                                                className="order-xs-1 order-xl-2"
                                                                            >
                                                                                {filteredResources && (
                                                                                    <div
                                                                                        className="bg-white border rounded-1 px-4 py-3 d-flex flex-column mt-2 mt-lg-0"
                                                                                        style={{
                                                                                            height: isColumn ? "390px" : "300px",
                                                                                        }}
                                                                                    >
                                                                                        <h5 className="fs-5 fw-semibold pb-2 mb-3 border-bottom flex-shrink-0 rv-text-color px-2">
                                                                                            Usage
                                                                                        </h5>
                                                                                        <div className="flex-grow-1" style={{ overflowY: "auto" }}>
                                                                                            <Table className="mb-0 align-middle table-responsive">
                                                                                                <thead className="bg-white sticky-top">
                                                                                                    <tr>
                                                                                                        <th className="fw-semibold">Name</th>
                                                                                                        <th className="fw-semibold">Value</th>
                                                                                                        <th className="fw-semibold">Units</th>
                                                                                                        <th className="fw-semibold d-none d-sm-table-cell">Time&nbsp;Period</th>
                                                                                                    </tr>
                                                                                                </thead>
                                                                                                <tbody>
                                                                                                    {resources.filter((res => res.offerName === carouselSubscription))?.map((r, idx) => (
                                                                                                        <tr
                                                                                                            key={idx}
                                                                                                            style={idx ? { borderTop: "1px solid #f1f3f5" } : undefined}
                                                                                                        >
                                                                                                            <td style={{ wordBreak: "break-word", maxWidth: "120px" }}>{r.resourceName}</td>
                                                                                                            <td style={{ wordBreak: "break-word" }}>
                                                                                                                <FormattedNumber value={r.consumedBalance} uom="" showUom={false} maxLength={20} isTruncateMiddle={true} />
                                                                                                            </td>
                                                                                                            <td style={{ wordBreak: "break-word" }}>{r.uom}</td>
                                                                                                            <td className="d-none d-sm-table-cell" style={{ fontSize: "0.9rem" }}>
                                                                                                                {`${formatDate(r.validFrom)} – ${formatDate(r.validTo)}`}
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                    ))}
                                                                                                </tbody>
                                                                                            </Table>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    )}
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </Col>
                                        </Row>) :
                                        <>
                                            <Row className="align-items-end mt-4 mb-3">
                                                <Col xs={12}>
                                                    <div className="d-flex align-items-end">
                                                        {uniqueSubscriptionIds?.length > 0 && <h5 className="rv-page-title p-1">Subscriptions List</h5>}

                                                        {roleName !== "Customer" && !isEIPEnabled && (
                                                            <div className="d-flex gap-2 ms-auto">
                                                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                                                    <DropdownToggle caret className="d-flex bg-secondary text-white rounded-1 px-4 py-1 align-items-center">
                                                                        Adjust
                                                                    </DropdownToggle>
                                                                    <DropdownMenu>
                                                                        <DropdownItem
                                                                            className="text-primary border-bottom"
                                                                            onClick={() => {
                                                                                setModalType("Adjust");
                                                                                setModalOpen(true);
                                                                            }}
                                                                        >
                                                                            Currency
                                                                        </DropdownItem>
                                                                        <DropdownItem
                                                                            className="text-primary"
                                                                            onClick={() => {
                                                                                setModalType("Adjustment");
                                                                                setModalOpen(true);
                                                                            }}
                                                                        >
                                                                            Non - Currency
                                                                        </DropdownItem>
                                                                    </DropdownMenu>
                                                                </Dropdown>
                                                                <CommonButton
                                                                    color="secondary"
                                                                    className="bg-secondary text-white rounded-1 px-4 py-1"
                                                                    buttonAction={() => {
                                                                        setModalType("Recharge");
                                                                        setModalOpen(true);
                                                                    }}
                                                                    buttonText={"Recharge"}
                                                                />
                                                            </div>
                                                        )}

                                                    </div>
                                                </Col>
                                            </Row>
                                            {uniqueSubscriptionIds?.length == 0 && <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
                                                {"No active subscriptions."}
                                            </div>}
                                        </>}
                                </>
                            )
                        ) : (
                            <>
                                <Row className="align-items-end mt-4 mb-3">
                                    <Col xs={12}>
                                        <div className="d-flex justify-content-end align-items-end">

                                            {roleName !== "Customer" && !isEIPEnabled && (
                                                <div className="d-flex gap-2">
                                                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                                        <DropdownToggle caret className="d-flex bg-secondary text-white rounded-1 px-4 py-1 align-items-center">
                                                            Adjust
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem
                                                                className="text-primary border-bottom"
                                                                onClick={() => {
                                                                    setModalType("Adjust");
                                                                    setModalOpen(true);
                                                                }}
                                                            >
                                                                Currency
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                className="text-primary"
                                                                onClick={() => {
                                                                    setModalType("Adjustment");
                                                                    setModalOpen(true);
                                                                }}
                                                            >
                                                                Non - Currency
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                    <CommonButton
                                                        color="secondary"
                                                        className="bg-secondary text-white rounded-1 px-4 py-1"
                                                        buttonAction={() => {
                                                            setModalType("Recharge");
                                                            setModalOpen(true);
                                                        }}
                                                        buttonText={"Recharge"}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
                                    {(fetchCustomerSummaryDataError && typeof fetchCustomerSummaryDataError === 'string') ? fetchCustomerSummaryDataError : "No active subscriptions."}
                                </div>
                            </>

                        )}
                        {(selectedSubscriptionId && groupedResources &&
                            Object.keys(groupedResources)?.filter(key => key.startsWith(selectedSubscriptionId)).length > 0 && uniqueSubscriptionIds?.length > 0) && <h5 className="rv-page-title mt-3">Subscriptions List</h5>}
                    </div>
                </Col>
                <CustomerAdjustmentModal
                    modalOpen={modalOpen}
                    toggleModal={toggleModal}
                    modalType={modalType}
                    initialRechargeValues={initialRechargeValues}
                    initialCurrencyAdjustValues={initialCurrencyAdjustValues}
                    initialAdjustValues={initialAdjustValues}
                    handleBalanceConfirm={handleBalanceConfirm}
                    handleConfirm={handleConfirm}
                    currencyRechargeArray={currencyRechargeArray}
                    currencyAdjustArray={currencyAdjustArray}
                    nonCurrencyAdjustArray={nonCurrencyAdjustArray}
                    idArray={idArray}
                    subscriptionIdArray={subscriptionIdArray}
                    offerCodeArray={offerCodeArray}
                    chargedResource={chargedResource}
                    setModalOpen={setModalOpen}
                />
            </Row >
        </>
    )
};
export default CustomerProfile;